import { rankings } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';
import { Link } from 'react-router-dom';

export default function RankingSection() {
  return (
    <section id="rankings" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            人气排行榜
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            根据全网阅读量、收藏量和评分综合排序，发现最受欢迎的漫画作品
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {rankings.slice(0, 10).map((comic) => (
            <ComicCard key={comic.id} comic={comic} showRank />
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/korean"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border border-primary-300 text-primary-600 font-medium text-sm hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多漫画
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}